<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="">品牌活动</router-link></li>
                <li class="currentNode"><a>{{ title }}</a></li>
            </ul>
            <div class="page-main">
                <ul class="vertical-nav">
                    <li class="rootMenu"><a>品牌活动</a></li>
                    <li><router-link to="/layout/salon?id=1" :class="{'active': id === '1'}">驻京沙龙</router-link></li>
                    <li><router-link to="/layout/salon?id=2" :class="{'active': id === '2'}">专家讲坛</router-link></li>
                    <li><router-link to="/layout/salon?id=3" :class="{'active': id === '3'}">项目路演</router-link></li>
                </ul>
                <div class="page-content">
                    <h3>{{ title }}</h3>
                    <ul class="branch-list">
                        <li class="branch-item"  v-for="brand in brandList" :key="brand.Id">
                            <img  :src="brand.ImageUrl" />
                            <div class="branch-item-memo">
                                <h4>{{ brand.Title }}</h4>
                                <p>{{ brand.SubTitle }}</p>
                            </div>
                        </li>
                        <!-- <li class="branch-item">
                            <img src="@/assets/image/enterprise/enterpriseBranch1.png" />
                            <div class="branch-item-memo">
                                <h4>跨媒体艺术与数字共生主题</h4>
                                <p>行业内的企业聚集在一起进行讨论的会议活动</p>
                            </div>
                        </li>
                        <li class="branch-item">
                            <img src="@/assets/image/enterprise/enterpriseBranch1.png" />
                            <div class="branch-item-memo">
                                <h4>跨媒体艺术与数字共生主题</h4>
                                <p>行业内的企业聚集在一起进行讨论的会议活动</p>
                            </div>
                        </li>
                        <li class="branch-item">
                            <img src="@/assets/image/enterprise/enterpriseBranch1.png" />
                            <div class="branch-item-memo">
                                <h4>跨媒体艺术与数字共生主题</h4>
                                <p>行业内的企业聚集在一起进行讨论的会议活动</p>
                            </div>
                        </li>
                        <li class="branch-item">
                            <img src="@/assets/image/enterprise/enterpriseBranch1.png" />
                            <div class="branch-item-memo">
                                <h4>跨媒体艺术与数字共生主题</h4>
                                <p>行业内的企业聚集在一起进行讨论的会议活动</p>
                            </div>
                        </li> -->
                    </ul>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        @current-change="handleCurrentChange">
                    </el-pagination>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import {
    getPingpaiActivityList,
} from '@services/indexService.js'
export default {
    name:"",
    data() {
        return {
            title: '',
            id: '', //驻京沙龙1，专家讲坛2，项目路演3
            brandList: [],
            total: 100,
         
        }
    },
    created() {
        this.traverseTitle();
        this.getPingpaiActivityList();
    },
    methods: {
        traverseTitle() {
            if (this.id === '1'){
                this.title = "驻京沙龙";
            } else if (this.id === '2'){
                this.title = "专家讲坛";
            } else {
                this.title = "项目路演";
            }
        },
        getPingpaiActivityList() {
            getPingpaiActivityList({current: 1, size: 12, type: this.id}).then(res => {
                console.log(res);
                if (res.Code == 1 && res.Data.length!==0) {
                    this.brandList = res.Data;
                } else {
                    this.$message.error("会员风采请求失败");
                }
            })
        },
        handleCurrentChange(pageNum) {

        }
    },
    watch: {
        // 监听路由对象中的变化
        '$route': {
            handler: function(to, from) {
                // 当路由发生变化时会调用这个函数
                // to 和 from 分别代表到达的路由和离开的路由
                this.id = to.query.id + "";
                this.getPingpaiActivityList()
                this.traverseTitle();
            },
            // 如果需要在路由变化时立即响应，可以设置immediate为true
            immediate: true
        }
    }
}
</script>

<style scoped>
.page-content h3{
    text-align:center;
}
.branch-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-bottom: 10px;
    padding-top: 10px;
}
.branch-item {
    width: 312px;
    border: 1px solid #E5E5E5;
    margin-bottom: 15px;
}
.branch-item img {
    width: 312px;
    height: 196px;
}
.branch-item-memo {
    padding: 15px;
}
.branch-item-memo h4 {
    font-family: 思源黑体 CN;
    font-size: 18px;
    color: #262626;
    margin-bottom: 10px;
}
.branch-item-memo p {
    font-family: 思源黑体 CN;
    font-size: 14px;
    color: #6A6A6A;
    line-height: 22px;
}
.branch-item-tip {
    display:flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
}
.branch-item-tip .doing {
    color: #4DC514;

}
.branch-item-tip .date {
    color: #A1A8B0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.branch-item-tip .date img {
    width: 15px;
    height: 15px;
}
.branch-item-tip .date i{
    font-style: normal;
    padding-left: 6px;
}
.el-divider--horizontal {
    margin: 10px 0;
}
</style>